<div class="model-select-dialog">
  <div class="dialog-header">
    <div class="title-placeholder"></div>
    <h2 class="dialog-title">Drag Any AI Into Any Tab</h2>
    <button class="exit-btn" (click)="dialogRef.close()">✕</button>
  </div>

  <!-- Apply button at top -->
  <div class="actions">
    <button mat-raised-button color="primary" (click)="apply()">Apply</button>
    <button mat-button (click)="dialogRef.close()">Cancel</button>
  </div>

  <!-- SCROLLABLE SECTION -->
  <div #dialogContainer class="scrollable-content">
    <!-- TOP: Available models -->
    <div class="available-row"
         cdkDropList
         id="availableList"
         [cdkDropListData]="availableModels"
         [cdkDropListConnectedTo]="['tab1','tab2','tab3','tab4']"
         (cdkDropListDropped)="drop($event)">
      <div class="model-card model-color"
           *ngFor="let model of availableModels"
           cdkDrag
           (cdkDragMoved)="onDragMoved($event)">
        {{ model.name }}
      </div>
    </div>

    <!-- BOTTOM: Four single-slot tab areas -->
    <div class="columns-container">
      <!-- Tab 1 -->
      <div class="column"
           cdkDropList
           id="tab1"
           [cdkDropListData]="tab1List"
           [cdkDropListConnectedTo]="['availableList','tab2','tab3','tab4']"
           (cdkDropListDropped)="drop($event)">
        <div class="column-title">Tab 1 - {{ tab1List[0]?.name || 'No model selected' }}</div>
        <div class="placeholder" *ngIf="tab1List.length === 0">Drag a model here</div>
        <div class="model-card"
             *ngFor="let model of tab1List"
             cdkDrag
             (cdkDragMoved)="onDragMoved($event)">
          {{ model.name }}
        </div>
      </div>

      <!-- Tab 2 -->
      <div class="column"
           cdkDropList
           id="tab2"
           [cdkDropListData]="tab2List"
           [cdkDropListConnectedTo]="['availableList','tab1','tab3','tab4']"
           (cdkDropListDropped)="drop($event)">
        <div class="column-title">Tab 2 - {{ tab2List[0]?.name || 'No model selected' }}</div>
        <div class="placeholder" *ngIf="tab2List.length === 0">Drag a model here</div>
        <div class="model-card"
             *ngFor="let model of tab2List"
             cdkDrag
             (cdkDragMoved)="onDragMoved($event)">
          {{ model.name }}
        </div>
      </div>

      <!-- Tab 3 -->
      <div class="column"
           cdkDropList
           id="tab3"
           [cdkDropListData]="tab3List"
           [cdkDropListConnectedTo]="['availableList','tab1','tab2','tab4']"
           (cdkDropListDropped)="drop($event)">
        <div class="column-title">Tab 3 - {{ tab3List[0]?.name || 'No model selected' }}</div>
        <div class="placeholder" *ngIf="tab3List.length === 0">Drag a model here</div>
        <div class="model-card"
             *ngFor="let model of tab3List"
             cdkDrag
             (cdkDragMoved)="onDragMoved($event)">
          {{ model.name }}
        </div>
      </div>

      <!-- Tab 4 -->
      <div class="column"
           cdkDropList
           id="tab4"
           [cdkDropListData]="tab4List"
           [cdkDropListConnectedTo]="['availableList','tab1','tab2','tab3']"
           (cdkDropListDropped)="drop($event)">
        <div class="column-title">Tab 4 - {{ tab4List[0]?.name || 'No model selected' }}</div>
        <div class="placeholder" *ngIf="tab4List.length === 0">Drag a model here</div>
        <div class="model-card"
             *ngFor="let model of tab4List"
             cdkDrag
             (cdkDragMoved)="onDragMoved($event)">
          {{ model.name }}
        </div>
      </div>

    </div>
  </div>
  <!-- END SCROLLABLE SECTION -->
</div>
